import { createSelector } from '@reduxjs/toolkit';
import { State } from './types';
import { RootState } from '../root-reducer';

export const rootSelector = (state: RootState): State => state.LatestCommunication;

export const statusSelector = createSelector(rootSelector, (state) => state.status);
export const errorSelector = createSelector(rootSelector, (state) => state.error);
export const dataSelector = createSelector(rootSelector, (state) => state.data);
